export default {
  filters: {
    pageNoText(pgno) {
      if (pgno === "F") return "Cover Page";
      else if (pgno === "B") return "Back Cover Page";
      else return `Page ${pgno}`;
    }
  }
};